<template lang="html">
  <div class="logo">
    <img v-if="white" src="../../assets/icons/logo_vibbra.svg" class="logo" />
    <img v-else src="static/logo.svg?v=1" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    white: Boolean,
  },
};
</script>

<style lang="scss">
.logo {
  position: relative;
  img {
    max-width: 100%;
    max-height: 100%;
  }
  .beta {
    position: absolute;
    color: #fff;
    bottom: 0;
    right: 0;
    line-height: 11px;
    display: block;
    font-size: 11px;
    opacity: 0.7;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/logo.vue